var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "remind" },
    [
      _c(
        "tippy-tooltip",
        {
          attrs: {
            trigger: "click",
            placement: _vm.placement,
            interactive: true,
          },
          on: { show: _vm.onShow },
          scopedSlots: _vm._u(
            [
              {
                key: "trigger",
                fn: function () {
                  return [_vm._t("default")]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        },
        [
          _vm._v(" "),
          _vm._l(_vm.data, function (item, index) {
            return _c(
              "z-link",
              {
                key: index,
                attrs: {
                  href: item.link,
                  target: "_blank",
                  download: item.type !== "google" ? item.name : "",
                },
              },
              [
                _c("z-icon", {
                  attrs: { name: item.type, width: "32", height: "32" },
                }),
                _vm._v("\n            " + _vm._s(item.type) + "\n        "),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }